import { z } from 'zod';
export var InsuranceType;
(function (InsuranceType) {
    InsuranceType["INSURANCE"] = "INSURANCE";
    InsuranceType["EXTENDED_WARRANTY"] = "EXTENDED_WARRANTY";
})(InsuranceType || (InsuranceType = {}));
export var InsuranceProvider;
(function (InsuranceProvider) {
    InsuranceProvider["ERGO"] = "ERGO";
    InsuranceProvider["CoverGenius"] = "CoverGenius";
})(InsuranceProvider || (InsuranceProvider = {}));
const priceSchema = z.object({
    includingVat: z.number(),
});
const attributeSchema = z.object({
    title: z.string(),
});
const baseQuoteSchema = z.object({
    insuranceQuoteId: z.string(),
    insuranceProductId: z.number(),
    title: z.string(),
    durationInYears: z.number(),
    insuranceType: z.nativeEnum(InsuranceType),
    inclusions: z.array(attributeSchema),
});
const quoteSchema = z.union([
    baseQuoteSchema.merge(z.object({
        paymentType: z.literal('MONTHLY'),
        premiums: z.object({
            recurring: priceSchema,
            yearly: priceSchema,
            oneTime: z.literal(null),
        }),
    })),
    baseQuoteSchema.merge(z.object({
        paymentType: z.literal('ONE_TIME'),
        premiums: z.object({
            oneTime: priceSchema,
            yearly: priceSchema,
            recurring: z.literal(null),
        }),
    })),
]);
export const partnerInsuranceSchema = z.object({
    insuranceQuotes: z.array(quoteSchema).nonempty(),
});
//# sourceMappingURL=types.js.map